"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _numeral = _interopRequireDefault(require("numeral"));

/**
 * @function
 *
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @param {string} [props.format='0,0.00']
 *
 * @returns {React.ReactNode}
 *
 * @example
 * // TODO: Write example.
 */
var NumberFormat = function NumberFormat(_ref) {
  var children = _ref.children,
      _ref$format = _ref.format,
      format = _ref$format === void 0 ? '0,0.00' : _ref$format;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (0, _numeral["default"])(children).format(format));
};

var _default = /*#__PURE__*/(0, _react.memo)(NumberFormat);

exports["default"] = _default;